import type {
	DateRange,
	Deployment,
	DeploymentFrequencyReportWithProviderInfo,
} from '../../common/types';
import { getProdDataState } from '../deployment-frequency-core/utils';
import type { PeriodBreakdown } from './types';

export const transformData = (
	perDeploymentMetrics: Deployment[],
	coreReportData: DeploymentFrequencyReportWithProviderInfo,
	selectedDateRange: DateRange,
): PeriodBreakdown => {
	const selectedPeriod = coreReportData.weeksData.find(
		(week) => week.startDateInclusive.getTime() === selectedDateRange.startDateInclusive.getTime(),
	);
	if (!selectedPeriod) {
		throw new Error('cannot find selected period in period breakdown');
	}
	return {
		periodProdDeployments: selectedPeriod.deploymentCount.prod,
		periodProdIssuesPerDeployment: selectedPeriod.medianIssuesPerDeployment.prod,
		medianProdDeployments: coreReportData.averageDeploymentCount,
		medianIssuesPerDeployment: coreReportData.medianIssuesPerDeployment,
		prodDataState: getProdDataState(coreReportData),
		perDeploymentMetrics,
		hasDeploymentProvider: coreReportData.hasDeploymentProvider,
	};
};
